import React, { useState, useEffect } from 'react';
import { authService } from '../_services'
import { Row, Col, Button, Form, Modal, Alert } from 'react-bootstrap'
import { useTranslation } from "react-i18next";
import { useDispatch } from 'react-redux'
import { alertActions } from '../_actions/alert.actions'
import { QRCodeSVG } from 'qrcode.react'

function Profile() {

	const [validated, setValidated] = useState(false);
	const [state, setState] = useState({password: '', repeatPassword: ''})
	const [twoFactorAuthenticationType, setTwoFactorAuthenticationType] = useState('NONE')
	const [hasSecret, setHasSecret] = useState(false)
	const [showTotpModal, setShowTotpModal] = useState(false)
	const [totpSecret, setTotpSecret] = useState('')
	const [totpCode, setTotpCode] = useState('')
	const [showTotpError, setShowTotpError] = useState(false)
	const {t} = useTranslation('common')
	const dispatch = useDispatch()

	useEffect(() => {
		authService.getTwoFactorAuthenticationValues().then(response => {
			console.log(response)
			setTwoFactorAuthenticationType(response.type)
			setHasSecret(response.hasSecret)
	    })
	}, [])

    const handleChange = (event) => {
        let name = event.target.name
        let value = event.target.value
        setState(prevState => ({
            ...prevState,
	        [name]: value
	    }));
    }

    const handleSubmit = (event) => {
	    event.preventDefault();
	    const form = event.currentTarget;
	    if (form.checkValidity() === false) {
			event.stopPropagation()
	        setValidated(true)
	    } else {
	        authService.updatePassword(state).then(response => {
				dispatch(alertActions.success(t('alerts.updatesuccessful')))
		    })
		    setState({password: '', repeatPassword: ''})
		    setValidated(false)
	    }
	};

	const getPattern = (password) => {
		if (!passwordsMatch()) {
			return "^$"
		}

		if (!containsCapitalLetter(password)) {
			return "^$"
		}

		if (!containsSpecialCharacter(password)) {
			return "^$"
		}

		return null
	}

	const passwordsMatch = () => {
		return state.password == state.repeatPassword
	}

	const containsCapitalLetter = (password) => {
		return /[A-ZÅÄÖ]/.test(password)
	}

	const containsSpecialCharacter = (password) => {
		var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
		return format.test(password)
	}

	const activateTotp = (e) => {
		authService.getTotpSecret().then(response => {
			console.log(response)

			setTotpSecret(response)
			setTotpCode('')
			setShowTotpError(false)
			setShowTotpModal(true)
	    })
	}

	const verifyTotp = (e) => {
		console.log('verifyTotp')
		var data = { secret: totpSecret, code: totpCode }
		authService.verifyTotp(data).then(response => {
			console.log(response)
			if (response == 'OK') {
				setShowTotpModal(false)
				setHasSecret(true)
			} else {
				setShowTotpError(true)
			}
	    })
	}

    return (
        <div>
		    <Row>
		        <Col sm="4">
		            <h2>
		                {t('profile.password')}
		            </h2>
		            <Alert variant="primary">
		                {t('profile.help')}
		            </Alert>
		            <Form id="password-form" noValidate onSubmit={handleSubmit} validated={validated}>
				        <Form.Group controlId="password">
				            <Form.Label>
				                {t('profile.password')}
				            </Form.Label>
				            <Form.Control
				                type="password"
				                placeholder={t('profile.password')}
				                name="password"
				                value={state.password}
				                onChange={handleChange}
				                required={true}
				                minLength={8}
				                pattern={getPattern(state.password)}
				            />
				            <Form.Control.Feedback type="invalid">
				                <ul>
					                { state.password == '' &&
					                    <li>
					                        {t('profile.emptypassword')}
					                    </li>
					                }
					                { state.password.length < 8 &&
					                    <li>
					                        {t('profile.shortpassword')}
					                    </li>
					                }
					                { !passwordsMatch() &&
					                    <li>
					                        {t('profile.mismatchingpasswords')}
					                    </li>
					                }
					                { !containsCapitalLetter(state.password) &&
					                    <li>
					                        {t('profile.nocapitalletter')}
					                    </li>
					                }
					                { !containsSpecialCharacter(state.password) &&
					                    <li>
					                        {t('profile.nospecialcharacter')}
					                    </li>
					                }
				                </ul>
                            </Form.Control.Feedback>
				        </Form.Group>
				        <Form.Group controlId="repeatpassword">
				            <Form.Label>
				                {t('profile.repeatpassword')}
				            </Form.Label>
				            <Form.Control
				                type="password"
				                placeholder={t('profile.repeatpassword')}
				                name="repeatPassword"
				                value={state.repeatPassword}
				                onChange={handleChange}
				                required={true}
				                minLength={8}
				                pattern={getPattern(state.repeatPassword)}
				            />
				            <Form.Control.Feedback type="invalid">
				                <ul>
					                { state.repeatPassword == '' &&
					                    <li>
					                        {t('profile.emptypassword')}
					                    </li>
					                }
					                { state.repeatPassword.length < 8 &&
					                    <li>
					                        {t('profile.shortpassword')}
					                    </li>
					                }
					                { !passwordsMatch() &&
					                    <li>
					                        {t('profile.mismatchingpasswords')}
					                    </li>
					                }
					                { !containsCapitalLetter(state.repeatPassword) &&
					                    <li>
					                        {t('profile.nocapitalletter')}
					                    </li>
					                }
					                { !containsSpecialCharacter(state.repeatPassword) &&
					                    <li>
					                        {t('profile.nospecialcharacter')}
					                    </li>
					                }
				                </ul>
                            </Form.Control.Feedback>
				        </Form.Group>
				        <Button type="submit">
				            {t('profile.update')}
				        </Button>
			        </Form>
		        </Col>
		        { twoFactorAuthenticationType != 'NONE' &&
			        <Col sm="4">
			            <h2>
			                {t('profile.2fa')}
			            </h2>
			            { twoFactorAuthenticationType == 'TOTP' &&
			                <>
			                    { hasSecret &&
			                        <span>
						                Tvåfaktorsautentisering med TOTP är aktiverat
						            </span>
			                    }
			                    { !hasSecret &&
			                        <Button onClick={activateTotp}>
							            {t('profile.activatetotp')}
							        </Button>
			                    }
					        </>
				        }
				        { twoFactorAuthenticationType == 'EMAIL' &&
				            <span>
				                Tvåfaktorsautentisering med e-post är aktiverat
				            </span>
				        }
			        </Col>
		        }
		    </Row>
		    <Modal
				style={{overflow: 'scroll'}}
				size="md"
				show={showTotpModal}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={() => setShowTotpModal(false)}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						TOTP
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div>
						{t('profile.totpsecretmessage')}
					</div>
					<QRCodeSVG value={"otpauth://totp/Telcodox?secret=" + totpSecret}/>
					<div>
						{totpSecret}
					</div>
					<div style={{marginTop: 20}}>
		                {t('profile.totpcodemessage')}
		                <Form.Control required type="text" placeholder={t('profile.code')} name="code" value={totpCode} onChange={e => setTotpCode(e.target.value)}/>
					</div>
					{ showTotpError &&
						<Alert variant="danger">
			                {t('profile.totperror')}
			            </Alert>
					}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="primary" onClick={verifyTotp} disabled={totpCode == ''}>
						{t('crudtable.ok')}
					</Button>
				</Modal.Footer>
			</Modal>
	    </div>
    )
}

export default Profile;